const adminWpRouter = [
  {
    path: '/admin/wp',
    name: 'AdminWpIndex',
    component: () => import('@/views/admin/wp/index')
  },
  {
    path: '/admin/wp/create',
    name: 'AdminWpCreate',
    component: () => import('@/views/admin/wp/create')
  },
  {
    path: '/admin/wp/edit',
    name: 'AdminWpEdit',
    component: () => import('@/views/admin/wp/edit')
  }
]

export default adminWpRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/wp.js